import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpimprichichwad() {



  const cardData = {
"keyword": "Mini Bus On Rent in Pimpri Chinchwad",

"headingDescription":
  "Aaradhya Travels offers reliable Mini Bus On Rent in Pimpri Chinchwad for corporate travel, employee transportation, weddings, family trips, airport transfers, school tours, industrial visits, and outstation group journeys. Our fleet includes comfortable 14, 17, 20, 25, 32, and 35-seater mini buses equipped with air-conditioning, pushback seats, spacious interiors, and experienced drivers familiar with Pimpri, Chinchwad, Nigdi, Akurdi, and PCMC industrial routes. We ensure safe, comfortable, and punctual group transportation with doorstep pickup across the entire Pimpri-Chinchwad region.",

"topPlaces": [
{
"title": "Lonavala",
"description":
"Lonavala is one of the most famous hill stations near Pune known for green valleys, Tiger Point, Bhushi Dam, caves, and monsoon beauty. It is widely visited by family groups, corporate teams, and friends for short and comfortable bus trips."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city near Pune known for lakeside promenade, colorful buildings, cafes, and peaceful environment. It is ideal for relaxed group outings, corporate trips, and family leisure travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a scenic lakeside destination near Lonavala known for camping, sunset views, bonfire nights, and peaceful surroundings. It is highly popular among group travelers and weekend tourists from Pune."
},
  {
"title": "Khandala",
"description":
"Khandala is a popular hill station near Pune known for its misty mountains, scenic viewpoints, waterfalls, and pleasant weather. It is a favorite weekend getaway for families and group travelers using buses and Tempo Travellers for comfortable short road trips."
},

{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for toy train rides, viewpoints, and cool weather. It is perfect for peaceful group travel and family sightseeing tours from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a calm hill station known for Arthur Lake, Randha Falls, and natural beauty. It is a perfect relaxing destination for group tours and weekend trips from Pune."
},
{
"title": "Kamshet",
"description":
"Kamshet is a scenic hill region near Pune famous for paragliding, green valleys, and peaceful landscapes. It is popular among adventure lovers and group travelers looking for short trips."
},
{
"title": "Mulshi",
"description":
"Mulshi is a beautiful lake and dam destination near Pune surrounded by hills and greenery. It is a popular picnic and one-day group travel destination for families and corporate outings."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic mountain pass known for waterfalls, fog, and lush greenery during monsoon. It is a favorite short road trip destination for group travelers from Pune."
},
{
"title": "Aamby Valley",
"description":
"Aamby Valley is a luxury hill township near Lonavala known for scenic landscapes, lakes, and premium resorts. It is popular for corporate trips, luxury group outings, and weekend leisure travel."
}
],



services: [
  {
    name: "Pimpri Chinchwad Mini Bus Hire",
    description: "Pimpri Chinchwad mini bus hire service provides reliable transportation for airport transfers, office outings, sightseeing tours, family trips, and group travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient mini bus hire reservations."
  },
  {
    name: "PCMC Bus Rental Service Pune",
    description: "PCMC bus rental service Pune offers dependable transportation for employee travel, educational tours, wedding functions, sightseeing trips, and corporate passenger movement requirements. Spacious buses ensure smooth journeys suitable for local and outstation transportation needs. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across PCMC Pune. Flexible booking options allow convenient bus rental service reservations."
  },
  {
    name: "Pimpri Chinchwad Corporate Bus",
    description: "Pimpri Chinchwad corporate bus service provides professional transportation for office staff, conferences, business meetings, corporate outings, and employee travel requirements. Comfortable buses ensure smooth journeys suitable for executive passengers and office teams. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and business locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Pimpri Wedding Bus Hire",
    description: "Pimpri wedding bus hire service offers stylish transportation for marriage ceremonies, bridal parties, wedding guests, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and event transportation. Professional drivers ensure punctual pickup and reliable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient wedding bus hire reservations."
  },
  {
    name: "Pimpri Group Travel Bus Pune",
    description: "Pimpri group travel bus Pune service provides spacious transportation for educational tours, sightseeing journeys, family vacations, office outings, and tourist travel. Comfortable buses ensure smooth travel suitable for medium and large passenger groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pimpri Pune. Flexible booking options allow convenient group travel bus reservations."
  },
  {
    name: "Pimpri AC Mini Bus Rental",
    description: "Pimpri AC mini bus rental service provides premium air-conditioned transportation for business travel, airport transfers, office outings, sightseeing tours, and group journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Pimpri Pune. Flexible booking options allow convenient AC mini bus rental reservations."
  },
  {
    name: "Pimpri Non AC Bus Hire",
    description: "Pimpri non AC bus hire service offers affordable transportation for educational tours, office travel, sightseeing trips, wedding functions, and group journeys. Spacious seating ensures comfortable travel suitable for budget-friendly local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient non AC bus hire reservations."
  },
  {
    name: "17 Seater PCMC Bus",
    description: "17 seater PCMC bus service provides spacious transportation for family vacations, office outings, educational tours, and group travel requirements. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across PCMC Pune. Flexible booking options allow convenient 17 seater bus reservations."
  },
  {
    name: "25 Seater PCMC Bus Pune",
    description: "25 seater PCMC bus Pune service offers reliable transportation for corporate events, wedding functions, office travel, educational tours, and sightseeing journeys. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for larger passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across PCMC Pune. Flexible booking options allow convenient 25 seater bus reservations."
  },
  {
    name: "Pimpri Outstation Bus Service",
    description: "Pimpri outstation bus service provides dependable long-distance transportation for Goa tours, pilgrimage journeys, sightseeing trips, family vacations, and tourist travel. Spacious seating and luggage space ensure comfortable highway journeys suitable for all passenger groups. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient outstation bus service reservations."
  },
  {
    name: "Pimpri to Lonavala Bus",
    description: "Pimpri to Lonavala bus service offers comfortable transportation for sightseeing tours, family vacations, weekend trips, and tourist travel to the hill station destination. Spacious buses ensure smooth expressway travel suitable for family and group journeys. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pimpri Pune. Flexible booking options allow convenient Lonavala bus reservations."
  },
  {
    name: "Pimpri to Mahabaleshwar Bus",
    description: "Pimpri to Mahabaleshwar bus service provides reliable transportation for hill station vacations, sightseeing journeys, tourist travel, and family outings from Pimpri Pune. Spacious seating and smooth ghat road travel ensure pleasant journeys suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient Mahabaleshwar bus reservations."
  },
  {
    name: "Pimpri Airport Pickup Bus",
    description: "Pimpri airport pickup bus service offers reliable transportation for airport pickups, business travelers, family travel, office staff movement, and tourist passenger transfers. Spacious buses ensure comfortable travel suitable for local and outstation airport transportation requirements. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient airport pickup bus reservations."
  },
  {
    name: "Pimpri Hinjewadi Bus Service",
    description: "Pimpri Hinjewadi bus service offers dependable transportation for office commute, business travel, IT employee movement, and corporate shuttle requirements. Comfortable buses ensure smooth journeys suitable for office staff and business passenger travel. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and IT parks across Pimpri and Hinjewadi Pune. Flexible booking options allow convenient Hinjewadi bus service reservations."
  },
  {
    name: "Pimpri Wakad Bus Hire",
    description: "Pimpri Wakad bus hire service provides comfortable transportation for office travel, sightseeing tours, family outings, and local passenger movement. Spacious buses ensure smooth journeys suitable for local group travel requirements and daily commute services. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri and Wakad Pune. Flexible booking options allow convenient Wakad bus hire reservations."
  },
  {
    name: "Pimpri Baner Bus Rental",
    description: "Pimpri Baner bus rental service offers reliable transportation for office travel, wedding functions, educational tours, and sightseeing journeys. Comfortable seating and smooth travel ensure pleasant journeys suitable for family and corporate groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri and Baner Pune. Flexible booking options allow convenient Baner bus rental reservations."
  },
  {
    name: "Pimpri Kothrud Bus Service",
    description: "Pimpri Kothrud bus service provides dependable transportation for office commute, airport transfers, sightseeing journeys, and local group passenger movement requirements. Spacious buses ensure smooth journeys suitable for family and business passengers. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri and Kothrud Pune. Flexible booking options allow convenient Kothrud bus service reservations."
  },
  {
    name: "Pimpri Chinchwad Family Bus",
    description: "Pimpri Chinchwad family bus service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious buses ensure comfortable journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient family bus reservations."
  },
  {
    name: "Pimpri Affordable Bus Rental",
    description: "Pimpri affordable bus rental service provides economical transportation for educational tours, office travel, sightseeing journeys, family outings, and local or outstation group trips. Spacious seating and luggage space ensure comfortable travel experiences suitable for budget-friendly transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Pune. Flexible booking options allow convenient affordable bus rental reservations."
  },
  {
    name: "Pimpri Luxury Bus Hire",
    description: "Pimpri luxury bus hire service offers premium transportation with elegant interiors and spacious seating for corporate travel, weddings, sightseeing tours, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, luxury hotels, and airports across Pimpri Pune. Flexible booking options allow convenient luxury bus hire reservations."
  },
  {
    name: "Pimpri Picnic Bus Pune",
    description: "Pimpri picnic bus Pune service provides comfortable transportation for family outings, school trips, office picnics, sightseeing tours, and holiday travel. Spacious buses ensure smooth journeys suitable for local and outstation picnic travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, and residential areas across Pimpri Pune. Flexible booking options allow convenient picnic bus reservations."
  },
  {
    name: "Pimpri Corporate Outing Bus",
    description: "Pimpri corporate outing bus service offers professional transportation for office picnics, employee outings, conferences, and team-building travel requirements. Comfortable buses ensure smooth journeys suitable for corporate groups and executive travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from offices, hotels, and business hubs across Pimpri Pune. Flexible booking options allow convenient corporate outing bus reservations."
  },
  {
    name: "Pimpri Tourist Bus Booking",
    description: "Pimpri tourist bus booking service provides dependable transportation for sightseeing tours, holiday vacations, family outings, and tourist travel requirements. Spacious buses ensure comfortable journeys suitable for local and outstation tourism activities. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pimpri Pune. Flexible booking options allow convenient tourist bus booking reservations."
  },
  {
    name: "Pimpri Travel Service Pune",
    description: "Pimpri travel service Pune offers spacious transportation for weddings, educational tours, sightseeing journeys, office outings, and family group travel requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pimpri Pune. Flexible booking options allow convenient travel service reservations."
  },
  {
    name: "Pimpri Group Booking Bus",
    description: "Pimpri group booking bus service provides reliable transportation for corporate outings, wedding events, sightseeing journeys, educational tours, and tourist group travel. Spacious buses ensure smooth travel suitable for medium and large passenger groups with comfortable seating and luggage space. Professional drivers ensure dependable transportation and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient group booking bus reservations."
  }
],

tableData: [
  ["Pimpri Chinchwad Mini Bus Hire", "PCMC Bus Rental Service Pune"],
  ["Pimpri Chinchwad Corporate Bus", "Pimpri Wedding Bus Hire"],
  ["Pimpri Group Travel Bus Pune", "Pimpri AC Mini Bus Rental"],
  ["Pimpri Non AC Bus Hire", "17 Seater PCMC Bus"],
  ["25 Seater PCMC Bus Pune", "Pimpri Outstation Bus Service"],
  ["Pimpri to Lonavala Bus", "Pimpri to Mahabaleshwar Bus"],
  ["Pimpri Airport Pickup Bus", "Pimpri Hinjewadi Bus Service"],
  ["Pimpri Wakad Bus Hire", "Pimpri Baner Bus Rental"],
  ["Pimpri Kothrud Bus Service", "Pimpri Chinchwad Family Bus"],
  ["Pimpri Affordable Bus Rental", "Pimpri Luxury Bus Hire"],
  ["Pimpri Picnic Bus Pune", "Pimpri Corporate Outing Bus"],
  ["Pimpri Tourist Bus Booking", "Pimpri Travel Service Pune"],
  ["Pimpri Group Booking Bus", "Pimpri Chinchwad Mini Bus Hire"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Mini Bus On Rent in Pimpri Chinchwad",
        WhyChoosedescription: "Aaradhya Travels provides reliable mini bus rental service in Pimpri Chinchwad with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate tours, family trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Mini Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable mini bus on rent in Pimpri Chinchwad with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking Service",
        WhyChoosedescription: "Our mini bus rental service in Pimpri Chinchwad operates 24 hours for airport transfers, employee transportation, weddings, school trips, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Mini Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses suitable for office teams, family groups, wedding travel, tourists, and school transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service Across Pimpri Chinchwad",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Pimpri, Chinchwad, Nigdi, Akurdi, Wakad, Ravet, Pimple Saudagar, Bhosari, and nearby Pune locations for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is mini bus on rent in Pimpri Chinchwad?", answer: "Mini bus rental service in Pimpri Chinchwad provides comfortable group transportation for corporate travel, family tours, weddings, school trips, and outstation journeys." },
    { question: "Is mini bus booking available 24 hours in Pimpri Chinchwad?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus rental service in Pimpri Chinchwad." },
    { question: "Which mini bus seating options are available?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses for different group travel requirements." },
    { question: "Can I book mini bus for outstation travel from Pimpri Chinchwad?", answer: "Yes, customers can book mini buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Pimpri Chinchwad." },
    { question: "Do you provide mini buses for corporate events in Pimpri Chinchwad?", answer: "Yes, Aaradhya Travels provides mini bus rental service for corporate meetings, office outings, conferences, and employee transportation in Pimpri Chinchwad." },
    { question: "Are AC and Non-AC mini buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly group travel." },
    { question: "Can I book mini bus online in Pimpri Chinchwad?", answer: "Yes, customers can easily book mini bus rental service online or through phone booking." },
    { question: "Do you provide mini buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for weddings, family vacations, and group tours." },
    { question: "Are mini bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for mini bus rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Jagtap",
    feedback:
      "Traveling across Pimpri Chinchwad with a group became very convenient with a mini bus arranged by Aaradhya Travels. The journey was smooth, and everyone could travel together without any confusion or delays.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishnavi Kulkarni",
    feedback:
      "Aaradhya Travels managed our mini bus on rent in Pimpri Chinchwad very well. The vehicle was clean, spacious, and made our family travel experience comfortable and well organized.",
    rating: 5
  }
];






  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pimpri Chinchwad",
  "image": "https://www.aaradhyatravels99.com/assets/images/mini-bus-on-rent-in-pimpri-chinchwad.jpg",
  "description": "Book Mini Bus on rent in Pimpri Chinchwad (PCMC) with Aaradhya Travels for corporate travel, weddings, airport transfers, IT transport, family trips, and outstation journeys. Available AC and Non-AC 17 and 25 seater mini buses across Pimpri Chinchwad and nearby Pune areas.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/mini-bus-on-rent-in-pimpri-chinchwad"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Mini Bus on Rent in Pimpri Chinchwad | PCMC Corporate Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Mini Bus on rent in Pimpri Chinchwad with Aaradhya Travels. Affordable AC and Non-AC 17 and 25 seater mini buses available for corporate travel, weddings, IT transport, airport pickup, family trips, and outstation tours to Lonavala and Mahabaleshwar."
  />

  <meta
    name="keywords"
    content="Pimpri Chinchwad mini bus hire, PCMC bus rental service Pune, Pimpri Chinchwad corporate bus, Pimpri wedding bus hire, Pimpri group travel bus Pune, Pimpri AC mini bus rental, Pimpri non AC bus hire, 17 seater PCMC bus, 25 seater PCMC bus Pune, Pimpri outstation bus service, Pimpri to Lonavala bus, Pimpri to Mahabaleshwar bus, Pimpri airport pickup bus, Pimpri Hinjewadi bus service, Pimpri Wakad bus hire, Pimpri Baner bus rental, Pimpri Kothrud bus service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpimprichichwad;